import types from "./actionTypes";
import { dealWithFields } from '../../undoredo/actions'
import { getFields } from './selectors';
import { arrayMove } from '../../../services/builder/util.js'


export const addField = (payload, noUndoRedo, associates) => (dispatch) => {

	if (noUndoRedo != true)
		dispatch(dealWithFields(payload, 'add', associates))

	dispatch({
		type: types.ADD_FIELD,
		payload,
	})
};

export const editField = (payload, noUndoRedo) => (dispatch) => {

	const editAssociates = {};

	if (payload.addUndoDepnedency != undefined) {
		editAssociates.addUndoDepnedency = payload.addUndoDepnedency;
		delete payload.addUndoDepnedency;
	}
	if (payload.deleteUndoDependency != undefined) {
		editAssociates.deleteUndoDependency = payload.deleteUndoDependency;
		delete payload.deleteUndoDependency;
	}

	if (noUndoRedo != true)
		dispatch(dealWithFields(payload, 'edit', editAssociates))

	dispatch({
		type: types.EDIT_FIELD,
		payload,
	})
};

export const deleteField = (payload) => ({
	type: types.DELETE_FIELD,
	payload,
})

export const updateFullFields = (fields) => ({
	type: types.UPDATE_FULL_FIELDS,
	payload: fields
})

export const moveOneFieldUpDown = (fieldID,direction) => (dispatch, getState) => {
	let fields = getFields(getState());
	let currentField = fields.find( field => field.id == fieldID );

	let ownFields = fields.filter( field => field.parent[0].id == currentField.parent[0].id );
	let otherFields = fields.filter( field => field.parent[0].id != currentField.parent[0].id );

	let currentIndex = ownFields.findIndex( field => field.id == fieldID );
	let newFields = arrayMove(ownFields,currentIndex, direction == 'up' ? currentIndex-1 : currentIndex+1);

	console.log({ownFields, newFields})

	dispatch(dealWithFields({
		orginalOrder: fields,
		afterReorder: [...otherFields, ...newFields]
	}, 'reorder'));

	dispatch({
		type: types.UPDATE_REORDERED_FIELDS,
		payload: [...otherFields, ...newFields]
	})
}

export const replaceFullFields = (fields) => ({
	type: types.UPDATE_REORDERED_FIELDS,
	payload: fields
})
